import {
  AsyncComponent,
  ConfiguredComponents,
} from '@r-and-a-shared-ui/core-component-config';
import { RenderOn } from '../../RenderOn/RenderOn';
import type { PlayerPortalsPageProps } from './types';

import styles from './PlayerPortalsPage.module.scss';

export const PlayerPortalsPagePreFooter = ({
  preFooter,
}: Pick<PlayerPortalsPageProps, 'preFooter'>) => {
  return (
    <section className={styles.prefooter}>
      <RenderOn condition={preFooter?.length > 0}>
        <div className={styles.container} data-testid={'page-prefooter'}>
          {preFooter?.map(x => (
            <AsyncComponent
              kontentItem={x}
              contentType={x.system.type as ConfiguredComponents}
              key={x.system.id}
            />
          ))}
        </div>
      </RenderOn>
    </section>
  );
};
